import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./element-variables.less";
Vue.config.productionTip = false;

import "./style/reset.css";
import "./style/login.less";
import "./components/toast.css";
import myToast from "./components/toast";
import element from "element-ui";
Vue.use(myToast);
Vue.use(element);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
